import React, { useEffect, useState } from 'react';
import '../css/Dashboard.css';

const API_URL = process.env.REACT_APP_API_URL || 'https://api.milstudio.in';

const Dashboard = () => {
  const [counts, setCounts] = useState({
    tables: null,
    chairs: null,
    products: null,
    categories: null,
    staff: null,
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchCounts = async () => {
      setLoading(true);
      try {
        // Fetch all in parallel (no revenue)
        const [
          tablesRes,
          chairsRes,
          productsRes,
          categoriesRes,
          staffRes
        ] = await Promise.all([
          fetch(`${API_URL}list-table.php`).then(r => r.json()),
          fetch(`${API_URL}list-chair.php`).then(r => r.json()),
          fetch(`${API_URL}product-list.php`).then(r => r.json()),
          fetch(`${API_URL}list-categories.php`).then(r => r.json()),
          fetch(`${API_URL}/list-stafflogin.php`).then(r => r.json()),
        ]);
        setCounts({
          tables: Array.isArray(tablesRes.data) ? tablesRes.data.length : 0,
          chairs: Array.isArray(chairsRes.data) ? chairsRes.data.length : 0,
          products: Array.isArray(productsRes.data) ? productsRes.data.length : 0,
          categories: Array.isArray(categoriesRes.categories) ? categoriesRes.categories.length : 0,
          staff: Array.isArray(staffRes.data) ? staffRes.data.length : 0,
        });
      } catch (e) {
        setCounts({ tables: 0, chairs: 0, products: 0, categories: 0, staff: 0 });
      } finally {
        setLoading(false);
      }
    };
    fetchCounts();
  }, []);

  return (
    <div className="dashboard-content">        
      <div className="dashboard-grid">
        <div className="dashboard-card">
          <div className="card-icon">🍽️</div>
          <h3>Tables</h3>
          <p>Manage restaurant tables</p>
          <div className="card-stats">
            <span className="stat-number">{loading ? '...' : counts.tables}</span>
            <span className="stat-label">Total Tables</span>
          </div>
        </div>
        
        <div className="dashboard-card">
          <div className="card-icon">🪑</div>
          <h3>Chairs</h3>
          <p>Manage restaurant seating</p>
          <div className="card-stats">
            <span className="stat-number">{loading ? '...' : counts.chairs}</span>
            <span className="stat-label">Total Chairs</span>
          </div>
        </div>
        
        <div className="dashboard-card">
          <div className="card-icon">📦</div>
          <h3>Products</h3>
          <p>Manage menu items</p>
          <div className="card-stats">
            <span className="stat-number">{loading ? '...' : counts.products}</span>
            <span className="stat-label">Menu Items</span>
          </div>
        </div>
        
        <div className="dashboard-card">
          <div className="card-icon">🏷️</div>
          <h3>Categories</h3>
          <p>Manage menu categories</p>
          <div className="card-stats">
            <span className="stat-number">{loading ? '...' : counts.categories}</span>
            <span className="stat-label">Categories</span>
          </div>
        </div>

        <div className="dashboard-card">
          <div className="card-icon">👥</div>
          <h3>Staff</h3>
          <p>Manage restaurant staff</p>
          <div className="card-stats">
            <span className="stat-number">{loading ? '...' : counts.staff}</span>
            <span className="stat-label">Total Staff</span>
          </div>
        </div>
      </div>

    </div>
  );
};

export default Dashboard; 